import type { RecordEditActionParams } from './useRecordEditAction';
import type { DocumentEditOwner } from 'src/document-editor/documentOwner';

type BuildEditActionTelemetryParams = Pick<
  RecordEditActionParams,
  'documentId' | 'actionText' | 'source' | 'conversationId'
> & {
  owner?: DocumentEditOwner | null;
};

export function buildEditActionTelemetry({
  documentId,
  actionText,
  source,
  conversationId,
  owner,
}: BuildEditActionTelemetryParams): RecordEditActionParams {
  return {
    documentId,
    actionText,
    source,
    conversationId,
    ...(owner ?? {}),
  };
}
